import { useEffect, useState } from 'react';
import { Banner, Footer, Navbar } from '../components';
import { Typography } from '@material-tailwind/react';

const FEES_LIST = [
  "Conference attendance;",
  "Certificate of attendance;",
  "Annual membership fee of APRP;",
  "Lunch;",
  "Coffee breaks.",
]
const registrationCost = "60"

export function Registration() {
  const [navbarTransparent, setNavbarTransparent] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="w-full relative">
        <Navbar transparent={navbarTransparent} />
        <Banner title={"Registration"} />

        <section className="w-full container mx-auto py-12 px-14" >

          <div className="flex flex-col justify-center  w-full h-full p-8">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Registrations fees
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              The registration fee is <strong>{registrationCost}</strong> euros and includes:
            </Typography>

            <ul className="list-disc font-normal mt-4 pl-4" >
              {FEES_LIST.map((item) => (
                <li className="font-normal">
                  {item}
                </li>
              ))}
            </ul>


            <Typography color="gray" className="font-normal mt-2">
              In order to register, please fill the registration form below
            </Typography>
            <Typography color="blue-gray" className="mb-2 underline text-ubi-500 font-semibold">
              <a href="https://forms.gle/Ch99q4zgFwdgm3L27" target="_blank" >Registration form</a>
            </Typography>

            <Typography variant="h3" color="blue-gray" className="mb-2 mt-8">
              Financial Support for Students
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              APRP will support the participation of registered students who do not receive support from their respective institutions. The support amount per student will be the equivalent to a <strong>one-way ticket</strong>.
            </Typography>
          </div>

        </section>
        <Footer />

      </div>
    </>
  );
}
